const status = {
  created: 'created',
  approved: 'approved',
  processing: 'processing',
  succeeded: 'succeeded',
  succeededProcessing: 'succeeded_processing',
  failed: 'failed',
  failedProcessing: 'failed_processing',
  error: 'error'
};

module.exports = status;
